import { type ResponseWithPaginationMeta } from 'src/shared/api/types';
import { type ChangeEvent } from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Table } from 'src/shared/components/Table/Table';
import Pagination from 'src/shared/components/Pagination';
import { defaultTableRowsPerPageOptions } from 'src/shared/constants/table';
import { type FlexflowEmployeeDataToDisplay } from './types';
import { useGetColumns } from './constants';
import { type Employee } from 'src/shared/types/employee';

type ContractsPageContentProps = {
  data: ResponseWithPaginationMeta<FlexflowEmployeeDataToDisplay | Employee>;
  page: number;
  rowsPerPage: number;
  handleChangePage: (event: unknown, newPage: number) => void;
  handleChangeRowsPerPage: (event: ChangeEvent<HTMLInputElement>) => void;
  isRequestedAndActiveTab: boolean;
};

export const ContractPageContent = ({
  data,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  isRequestedAndActiveTab
}: ContractsPageContentProps) => {
  const columns = useGetColumns(data.data, isRequestedAndActiveTab);

  return (
    <>
      <Grid2 xs={12}>
        <Table rows={data.data} columns={columns} />
      </Grid2>
      <Grid2 xs={12} justifyContent="flex-end">
        <Pagination
          countAllRows={data.meta.total}
          onChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={defaultTableRowsPerPageOptions}
        />
      </Grid2>
    </>
  );
};
